import { useEffect } from "react";
import { handleReceivePostMessage } from "./helpers";

/**
 * @typedef {import("./types").HandleReceivePostMessageSettings} HandleReceivePostMessageSettings
 */

/**
 *
 * @param {object} props
 * @param {boolean} props.hasReceivedHandshakeFromPaymentIframe
 * @param {string} props.originOfPaymentIframe
 * @param {Function} props.setHasReceivedHandshakeFromPaymentIframe
 * @returns {null}
 */
const useListenToPaymentIframe = ({
    hasReceivedHandshakeFromPaymentIframe,
    originOfPaymentIframe,
    setHasReceivedHandshakeFromPaymentIframe,
}) => {
    /**
     *
     * @description Passes along all the data needed to complete the handshake.
     * @param {MessageEvent} message
     * @returns {void}
     */
    const handleIncomingPostMessage = (message) => {
        /** @type {HandleReceivePostMessageSettings} */
        const handleReceivePostMessageSettings = {
            hasReceivedHandshakeFromPaymentIframe,
            message,
            originOfPaymentIframe,
            setHasReceivedHandshakeFromPaymentIframe,
        };

        handleReceivePostMessage(handleReceivePostMessageSettings);
    };

    /**
     * @description Need to remove the listener when the component is
     * dismounted to prevent multiple listeners from existing concurrently if
     * the component is displayed and then removed from the UI repeatedly.
     * @returns {void}
     */
    useEffect(() => {
        window.addEventListener("message", handleIncomingPostMessage, false);

        return () =>
            window.removeEventListener("message", handleIncomingPostMessage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default useListenToPaymentIframe;
